import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import {
	EditRestaurantContext,
	IEditRestaurantContext,
} from '../../../../../../../editRestaurantState/editRestaurantContext';
import { useCompareFormData } from 'hooks/useCompareFormData';
import style from './BtnBlock.module.scss';

export const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		name,
		shortName,
		IDSelectedCustomer,
		clientType,
		IDSelectedCountry,
		IDSelectedCity,
		address,
		selectedCurrencySymbol,
		masterPhoneNumber,
		email,
		code,
		additionalApplications,
		vivaWalletIsv,
		supplier,
		isOpenPriceServiceCharge,
		openPricePercent,
		priceType,
		isUsedCustomerPriceType,
		loyalty,
		isUsedCustomerTips,
		tips0,
		tips1,
		tips2,
		tips3,
		defaultTips,
		tipsCommissionPercent,
		tipsCommissionMaxValue,
		isCharityEnabled,
		charityName,
		charityLogoPath,
		charityLogoFileId,
		charityAmount0,
		charityAmount1,
		charityAmount2,
		charityAmount3,
		defaultCharityAmountIndex,
		useKmTariff,
		isShowLoyaltyProgramButtons,
		baseMcc,
		useCustomerMcc,
		mccCards,
		mainMccCardBrand,
		mainMccCardMcc,
		downloadAppAndroidUrl,
		downloadAppIosUrl,
		IDDefaultLanguage,
		IDsLanguages,
		restrictionQrValue,
		usePosPhotos,
		enableStopListJob,
		useCustomerStopListSyncInterval,
		stopListSyncIntervalMinutes,
		updateOfTheLauncher,
		cardAcceptorId,
		cardAcceptorName,
		terminalId,
		vat,
		timeBlockChildAccess,
		IDPosSystem,
		launcherSettingFilePath,
		fileIdForLauncherSettings,
		useMenuVersion,
		useContentVersion,
		restaurantMenuVersion,
		restaurantContentVersion,
		useTlsCertificate,
		tlsCertificateLevel,
		tlsCertificateName,
		tlsCertificateFilePath,
		tlsCertificateFileId,
		vatId,
		kmVatId,
		bpaSetId,
		isApplicableForVat,
		paymentTypeId,
		extraPaymentTypes,
		initialFormData,
	} = useContext<IEditRestaurantContext>(EditRestaurantContext);

	const containerClasses = classNames(style.container, {
		[style.visible]:
			name ||
			IDSelectedCustomer ||
			clientType ||
			IDSelectedCountry ||
			IDSelectedCity ||
			address ||
			selectedCurrencySymbol ||
			masterPhoneNumber ||
			email ||
			code ||
			additionalApplications ||
			vivaWalletIsv ||
			supplier ||
			isOpenPriceServiceCharge ||
			openPricePercent ||
			priceType ||
			isUsedCustomerPriceType ||
			isUsedCustomerTips ||
			tips0 ||
			tips1 ||
			tips2 ||
			tips3 ||
			defaultTips ||
			tipsCommissionPercent ||
			tipsCommissionMaxValue ||
			isCharityEnabled ||
			charityName ||
			charityLogoPath ||
			charityLogoFileId ||
			charityAmount0 ||
			charityAmount1 ||
			charityAmount2 ||
			charityAmount3 ||
			defaultCharityAmountIndex ||
			useKmTariff ||
			isShowLoyaltyProgramButtons ||
			baseMcc ||
			useCustomerMcc ||
			mccCards ||
			mainMccCardBrand ||
			mainMccCardMcc ||
			downloadAppAndroidUrl ||
			downloadAppIosUrl ||
			IDDefaultLanguage ||
			IDsLanguages.length ||
			cardAcceptorId ||
			cardAcceptorName ||
			terminalId ||
			vat ||
			timeBlockChildAccess ||
			IDPosSystem ||
			restrictionQrValue ||
			usePosPhotos ||
			enableStopListJob ||
			updateOfTheLauncher ||
			fileIdForLauncherSettings ||
			useMenuVersion ||
			useContentVersion ||
			restaurantMenuVersion ||
			restaurantContentVersion ||
			useTlsCertificate ||
			tlsCertificateLevel ||
			tlsCertificateName ||
			tlsCertificateFilePath ||
			tlsCertificateFileId ||
			vatId ||
			kmVatId ||
			bpaSetId ||
			isApplicableForVat ||
			paymentTypeId,
	});

	const compareLauncherSettings = () => {
		if (fileIdForLauncherSettings) {
			return fileIdForLauncherSettings;
		}
		if (launcherSettingFilePath) {
			return launcherSettingFilePath;
		}
		return null;
	};

	const currentFormData = {
		name,
		shortName,
		IDSelectedCustomer,
		clientType,
		IDSelectedCountry,
		IDSelectedCity,
		address,
		selectedCurrencySymbol,
		masterPhoneNumber,
		email,
		code,
		additionalApplications,
		vivaWalletIsv,
		supplier,
		isOpenPriceServiceCharge,
		openPricePercent,
		priceType,
		isUsedCustomerPriceType,
		loyalty,
		isUsedCustomerTips,
		tips0,
		tips1,
		tips2,
		tips3,
		defaultTips,
		tipsCommissionPercent,
		tipsCommissionMaxValue,
		isCharityEnabled,
		charityName,
		charityLogoPath,
		charityLogoFileId,
		charityAmount0,
		charityAmount1,
		charityAmount2,
		charityAmount3,
		defaultCharityAmountIndex,
		useKmTariff,
		isShowLoyaltyProgramButtons,
		baseMcc,
		useCustomerMcc,
		mccCards,
		mainMccCardBrand,
		mainMccCardMcc,
		downloadAppAndroidUrl,
		downloadAppIosUrl,
		IDDefaultLanguage,
		IDsLanguages,
		restrictionQrValue,
		usePosPhotos,
		enableStopListJob,
		useCustomerStopListSyncInterval,
		stopListSyncIntervalMinutes,
		updateOfTheLauncher,
		cardAcceptorId,
		cardAcceptorName,
		terminalId,
		vat,
		timeBlockChildAccess,
		IDPosSystem,
		launcherSettingFilePath: compareLauncherSettings(),
		useMenuVersion,
		useContentVersion,
		restaurantMenuVersion,
		restaurantContentVersion,
		useTlsCertificate,
		tlsCertificateLevel,
		tlsCertificateName,
		tlsCertificateFilePath,
		tlsCertificateFileId,
		vatId,
		kmVatId,
		bpaSetId,
		isApplicableForVat,
		paymentTypeId,
		extraPaymentTypes: extraPaymentTypes,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={containerClasses}>
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					data-test="cancelBtn"
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button
					className={style.saveBtn}
					theme="primaryBlue"
					disabled={isEqualFormData}
					type="submit"
					data-test="saveBtn">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};
